module.exports = __webpack_public_path__ + "img/749-0290ee.png";